module.exports = __webpack_public_path__ + "Flama-Thin.woff2?355364a0c6210b244479e4ff6cce9c70";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Thin.woff2
// module id = 896
// module chunks = 0